// Skrypt motywu CTS „strona jak etykieta” (układ layout/cts.liquid). Port potrzebnej logiki z projekty/zasoby/strona.js —
// bez renderowania danych: treść (produkty, ceny, linie) wypisuje Liquid, tu tylko zachowanie strony.
// - menu na telefonie,
// - karta produktu: wybór wariantu (cena, dostępność, zdjęcie, adres ?variant=), ilość, miniatury,
//   podział opisu produktu na akordeon + krótki opis + znaczniki „Usuwa” (logika z narzedzia/zbuduj-dane.mjs),
// - koszyk: przyciski ilości i automatyczne przeliczenie po zmianie.
// Teksty z window.CTS_T (layout/cts.liquid, klucze cts.etykieta.* w locales: / -> pl.json, /en -> en.default.json).
(function () {
  'use strict';
  const T = window.CTS_T || {};
  const $ = (sel, el = document) => el.querySelector(sel);
  const $$ = (sel, el = document) => [...el.querySelectorAll(sel)];
  const esc = s => String(s ?? '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  // Stałe opisu produktu — PRZED kodem karty produktu, który od razu woła podzielOpis (const w strefie martwej = błąd).
  // Nagłówki sekcji opisu rozpoznajemy po polsku (/) i po angielsku (/en — opisy z tłumaczeń EN w sklepie).
  // Stan EN w sklepie (01.10.2026): sekcji „Usuwa”, „Film…” i „Uwaga: kupujesz opakowanie zbiorcze” w opisach EN nie ma —
  // wzorce EN są na zapas, gdyby tłumaczenia je dostały (Removes / Video / Note: you are buying a multipack).
  const WZ = {
    opis: /^(opis|description)/i,
    usuwa: /^(usuwa|removes)/i,
    film: /^(film|video)/i,
    zbiorcze: /^((uwaga|note|warning|attention): (kupujesz|you are (buying|purchasing)))/i,
  };
  const OPIS = T.opis || 'Opis';

  // ── menu na telefonie ──
  const ham = $('.hamburger'), panel = $('#panel-mobilny');
  if (ham && panel) {
    ham.addEventListener('click', () => {
      const otw = panel.classList.toggle('otwarty');
      ham.setAttribute('aria-expanded', otw);
    });
    // po kliknięciu dowolnego linku panel się zamyka (kotwica na tej samej stronie nie przeładowuje strony)
    panel.addEventListener('click', e => {
      if (!e.target.closest('a')) return;
      panel.classList.remove('otwarty');
      ham.setAttribute('aria-expanded', 'false');
    });
  }

  // ── pole ilości z przyciskami −/+ (karta produktu i koszyk) ──
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-ilosc]');
    if (!b) return;
    const pole = $('input', b.closest('.ilosc'));
    const min = +pole.min || 0, max = +pole.max || 999;
    pole.value = Math.min(max, Math.max(min, (parseInt(pole.value, 10) || 0) + +b.dataset.ilosc));
    pole.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ── karta produktu ──
  const formularz = $('[data-cts="formularz"]');
  if (formularz) {
    const duza = $('[data-cts="zdjecie"]');
    const miniatury = $$('.miniatury button');
    const pokaz = i => {
      const b = miniatury[i];
      if (!b || !duza) return;
      duza.src = b.dataset.src;
      miniatury.forEach((m, j) => m.setAttribute('aria-pressed', String(j === i)));
    };
    miniatury.forEach((b, i) => b.addEventListener('click', () => pokaz(i)));

    const cena = $('[data-cts="cena"]'), dostepnosc = $('[data-cts="dostepnosc"]'), przycisk = $('[data-cts="do-koszyka"]');
    formularz.addEventListener('change', e => {
      const r = e.target.closest('input[name="id"][type="radio"]');
      if (!r) return;
      const szablon = $(`template[data-cena-wariantu="${r.value}"]`);
      if (szablon && cena) cena.innerHTML = szablon.innerHTML;
      const jest = r.dataset.dostepny === 'true';
      przycisk.disabled = !jest;
      przycisk.textContent = jest ? T.do_koszyka : T.niedostepny;
      const znak = $('span', dostepnosc);
      if (znak) { znak.className = jest ? 'dostepny' : 'niedostepny'; znak.textContent = jest ? T.dostepny : T.chwilowo_niedostepny; }
      if (+r.dataset.zdjecie >= 0) pokaz(+r.dataset.zdjecie);
      const url = new URL(location.href);
      url.searchParams.set('variant', r.value);
      history.replaceState(null, '', url);
    });

    const opis = $('[data-cts="opis"]');
    if (opis) podzielOpis(opis);
  }

  // Opis produktu -> akordeon. Oczyszczanie i podział jak w narzedzia/zbuduj-dane.mjs (oczysc, sekcje, lista, krotkiOpis).
  function podzielOpis(opis) {
    const zrodlo = $('template[data-cts="opis-zrodlo"]', opis) || $('.tresc', opis);
    if (!zrodlo) return;
    const TAG = /<\/?([a-zA-Z0-9]+)((?:\s+[^\s=>\/]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+))?)*)\s*\/?>/g;
    const tekst = h => h.replace(/<[^>]+>/g, ' ').replace(/&amp;/g, '&').replace(/&gt;/g, '>').replace(/&lt;/g, '<')
      .replace(/&quot;/g, '"').replace(/\s+/g, ' ').trim();
    function oczysc(html) {
      let h = html.replace(/<!--[\s\S]*?-->/g, '').replace(/<(script|style)[\s\S]*?<\/\1>/gi, '');
      h = h.replace(TAG, (cale, tag) => {
        const t = tag.toLowerCase(), zam = cale.startsWith('</');
        if (/^h[1-6]$/.test(t)) return zam ? '</h4>' : '<h4>';
        if (t === 'b' || t === 'strong') return zam ? '</strong>' : '<strong>';
        if (['p', 'ul', 'ol', 'li', 'em'].includes(t)) return zam ? `</${t}>` : `<${t}>`;
        if (t === 'br') return '<br>';
        if (t === 'div') return '\n\n';
        return '';
      });
      h = h.replace(/ |&nbsp;/g, ' ').replace(/[ \t\r]+/g, ' ');
      h = h.replace(/<p>\s*<strong>\s*([^<]{2,40}?)\s*:?\s*<\/strong>\s*(?:<br>\s*)*/g, '<h4>$1</h4><p>');
      for (let i = 0; i < 3; i++) h = h.replace(/<(p|li|strong|em|ul|ol|h4)>\s*(?:<br>\s*)*<\/\1>/g, '');
      return h.trim();
    }
    function sekcje(html) {
      const wynik = [];
      const czesci = html.split(/<h4>([\s\S]*?)<\/h4>/);
      for (let i = 0; i < czesci.length; i += 2) {
        const tyt = i === 0 ? OPIS : tekst(czesci[i - 1]).replace(/[:\s]+$/, '');
        const bloki = [];
        const tresc = czesci[i];
        const re = /<(p|ul|ol)>[\s\S]*?<\/\1>/g;
        let ost = 0, m;
        const luzny = s => s.split(/\n\s*\n|(?:<br>\s*){2,}/).map(x => x.replace(/^(\s|<br>)+|(\s|<br>)+$/g, ''))
          .filter(x => tekst(x)).forEach(x => bloki.push(`<p>${x}</p>`));
        while ((m = re.exec(tresc))) { luzny(tresc.slice(ost, m.index)); if (tekst(m[0])) bloki.push(m[0].trim()); ost = re.lastIndex; }
        luzny(tresc.slice(ost));
        if (!tyt && !bloki.length) continue;
        wynik.push({ tyt: tyt || OPIS, html: bloki.join('\n') });
      }
      const scalone = [];
      for (const s of wynik) {
        if (!s.html) continue;
        const pop = scalone[scalone.length - 1];
        if (pop && pop.tyt.toLowerCase() === s.tyt.toLowerCase()) pop.html += '\n' + s.html;
        else scalone.push(s);
      }
      return scalone;
    }
    const lista = (sek, re) => {
      const s = sek.find(x => re.test(x.tyt));
      return s ? [...s.html.matchAll(/<li>([\s\S]*?)<\/li>/g)].map(m => tekst(m[1])).filter(Boolean) : [];
    };
    function krotkiOpis(sek) {
      const s = sek.find(x => WZ.opis.test(x.tyt)) ?? sek[0];
      if (!s) return '';
      const t = tekst(s.html.match(/<p>[\s\S]*?<\/p>/)?.[0] ?? s.html);
      if (t.length <= 240) return t;
      const zdania = t.match(/[^.!?]+[.!?]+/g) ?? [t];
      let w = '';
      for (const z of zdania) { if ((w + z).length > 240 && w) break; w += z; }
      return w.trim();
    }

    // pomijamy odsyłacz do filmu; ostrzeżenie „Uwaga: kupujesz opakowanie zbiorcze” zostaje tylko na stronie zestawu
    const zestaw = opis.dataset.zestaw === 'true';
    const sek = sekcje(oczysc(zrodlo.innerHTML)).filter(s => !WZ.film.test(s.tyt) && (zestaw || !WZ.zbiorcze.test(s.tyt)));
    if (!sek.length) return;
    opis.innerHTML = sek.map((s, i) => `<details${i === 0 ? ' open' : ''}><summary>${esc(s.tyt)}</summary><div class="tresc">${s.html}</div></details>`).join('');
    const krotko = $('[data-cts="krotko"]');
    if (krotko) krotko.textContent = krotkiOpis(sek);
    const usuwa = lista(sek, WZ.usuwa), blok = $('[data-cts="blok-usuwa"]');
    if (usuwa.length && blok) {
      $('[data-cts="usuwa"]', blok).innerHTML = usuwa.map(u => `<span>${esc(u)}</span>`).join('');
      blok.hidden = false;
    }
  }

  // ── koszyk: po zmianie ilości formularz przelicza się sam (bez JS — przycisk „Przelicz koszyk”) ──
  const koszyk = $('[data-cts="koszyk"]');
  if (koszyk) {
    let czas;
    koszyk.addEventListener('change', e => {
      if (!e.target.matches('input[name="updates[]"]')) return;
      clearTimeout(czas);
      czas = setTimeout(() => koszyk.requestSubmit ? koszyk.requestSubmit($('.przelicz', koszyk)) : koszyk.submit(), 500);
    });
  }
})();
